export default __webpack_public_path__ + "static/media/404.e710715b.svg";